<template>
    <div>
        <h2>Subscriptions</h2>
        <p>
            These are only the known subscriptions from Revenuecat,
            counting the updates received since August 2025.
            There might be more!
        </p>

        <table class="table">
            <thead>
                <tr>
                    <th>User</th>
                    <th>Entitlement</th>
                    <th>Status</th>
                    <th>Product</th>
                    <th>Platform</th>
                    <th>Cancellation reason</th>
                    <th>Last update received</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="subscription in subscriptions" :key="subscription.id">
                    <td><router-link :to="{ name: 'UserDetailView', params: { id: subscription.userId } }">{{
                    subscription.userId }}</router-link></td>
                    <td>{{ subscription.entitlement }}</td>
                    <td>{{ subscription.status }}</td>
                    <td>{{ subscription.product }}</td>
                    <td>{{ subscription.platform }}</td>
                    <td>{{ subscription.cancellationReason }}</td>
                    <td>{{ formatDate(subscription.updatedAt) }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { fetchSubscriptions } from '@/repository/apiService';

export default {
    data() {
        return {
            subscriptions: []
        };
    },
    created() {
        this.refresh();
    },
    methods: {
        async refresh() {
            try {
                this.subscriptions = await fetchSubscriptions();
            } catch (error) {
                console.error('Error fetching subscriptions:', error);
            }
        },
        formatDate(date) {
            if (date) {
                return (new Date(date)).toLocaleString();
            }
            return '';
        }
    }
};
</script>

<style>
.table {
    width: 100%;
    border-collapse: collapse;
    font-size: 10pt;
}

.table th,
.table td {
    border: 1px solid #ddd;
    padding: 8px;
}

.table th {
    background-color: #f4f4f4;
}
</style>
